import styled from "styled-components";

const BaseButton = styled.button`
  border-radius: ${(props) => props.theme.border.radius};
  height: 36px;
  padding: 0 1rem;
  font-family: ${(props) => props.theme.typography.fontFamily.main};
  font-weight: normal;
  font-size: 1rem;
  line-height: 1.375rem;
  color: ${(props) => props.theme.colors.primary.light};
  text-align: center;
  cursor: pointer;
  background-color: white;
  border: 2px solid ${(props) => props.theme.colors.primary.light};
  outline: none;
`;

export const AllocationWarningContainer = styled.div`
  padding: 16px;
`;

export const AllocationWarningTitle = styled.h2`
  margin: 0;
  padding: 0;
  font-size: 21px;
  line-height: 22px;
  color: #ff5200;
  text-transform: initial;
`;

export const AllocationWarningMessage = styled.p`
  margin: 16px 0;
  padding: 0;
  font-size: 16px;
  line-height: 22px;
  color: #474747;
`;

export const SolutionButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

export const CancelButton = styled(BaseButton)`
  border: 2px solid #767676;
  box-sizing: border-box;
  border-radius: 4px;
  color: #767676;
  margin-right: 0;
  min-width: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ConfirmButton = styled(BaseButton)`
  margin-right: 12px;
  background: ${(props) => props.theme.colors.primary.light};
  border-radius: 4px;
  border: 1px solid ${(props) => props.theme.colors.primary.light};
  color: white;
  min-width: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  &:disabled {
    background-color: #ccc;
    border-color: #ccc;
    cursor: not-allowed;
  }
`;

export const AllocationCloseWarningPopup = styled.div`
  position: absolute;
  background-color: white;
  top: 10%;
  left: 0;
  right: 0;
  width: 88%;
  margin: 0 auto;
  box-shadow: 1px 1px 1px 1px grey;
  padding: 16px;
`;
